import { tryLoadLightDOMStyles } from "../Global/loadDependency"
import { getTemplateNavHeaderBasicStyles } from "./NavHeader-Level0.styles"

const t = document.createElement('template')
t.innerHTML = `
<header class="ascend-header header-inner" role="banner">
  <nav class="main-nav" role="navigation" aria-label="Main Navigation">
    <!-- logo -->
    <slot name="logo"></slot>
    <!-- utility -->
    <slot name="utilityNavigation"></slot>
  </nav>
  <div class="tab-header">
      <slot name="primarySearchContainer"></slot> 
    </div>
</header>
`
const TemplateNavHeaderBasic = t

class NavHeaderBasic extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderBasicStyles().content.cloneNode(true))
    shadow.appendChild(TemplateNavHeaderBasic.content.cloneNode(true))
    tryLoadLightDOMStyles('NavHeader-Level0.css')

  }

  connectedCallback() {
    console.log('NavHeaderBasic connectedCallback')

    // Listen for search state changes from NavHeaderUtilitySearch
    this.addEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.addEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }

  disconnectedCallback() {
    this.removeEventListener('search-state-changed', this.handleSearchStateChange as EventListener)
    this.removeEventListener('search-icon-clicked', this.handleSearchIconClick as EventListener)
  }

  private handleSearchStateChange = (event: CustomEvent) => {
    const { visible } = event.detail
    const value = visible.toString()

    // Desktop / mobile search containers
    this.querySelectorAll('ts-navheader-search-container').forEach((el) =>
      el.setAttribute('search-visible', value),
    )

    // Utility button group
    this.querySelectorAll('ts-navheader-utility-buttongroup').forEach((el) =>
      el.setAttribute('search-visible', value),
    )
    console.log('Setting search-visible to', value)
    // Utility search icon
    this.querySelectorAll('ts-navheader-utility-search').forEach((el) =>
      el.setAttribute('search-visible', value),
    )
  }

  private handleSearchIconClick = (event: CustomEvent) => {
    // Optional: Handle search icon clicks for analytics, etc.
    console.log('Search icon clicked:', event.detail)
  }
}


if (!customElements.get('ts-navheader-level0')) {
  customElements.define('ts-navheader-level0', NavHeaderBasic)
}
export { NavHeaderBasic }
